import { ClientError } from 'graphql-request';

export const getErrorMessage = (error: ClientError) => {
  const { response, message } = error;

  if (response.errors?.length) {
    return response.errors[0].message;
  }

  if (message) {
    return message;
  }

  if (typeof window !== 'undefined' && !window.navigator.onLine) {
    return '네트워크 연결을 확인해주세요.';
  }
};
